import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=ba8ed4ce&scoped=true&"
import script from "./Popper.vue?vue&type=script&lang=js&"
export * from "./Popper.vue?vue&type=script&lang=js&"
import style0 from "./Popper.vue?vue&type=style&index=0&id=ba8ed4ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ed4ce",
  null
  
)

export default component.exports